import axios from "axios";

const url = process.env.REACT_APP_API_URL_REGISTER;
const urlFile = process.env.REACT_APP_API_URL_FILE;

export default class RegistrasiService {
    registerTrader(trader) {
        return axios.post(url + '/register', trader)
    }

    registerTraderFile(trader) {
        return axios.post(url + '/registerwithfile', trader)
    }

    registrasiUser(user) {
        return axios.post(url + '/user', user)
    }

    maxTrader() {
        return axios.get(url + '/register-max')
    }

    getTrader(trade) {
        return axios.get(url + '/trader/' + trade)
    }

    getTraderNPWP(npwp) {
        return axios.get(url + '/tradernpwp/' + npwp)
    }

    getPropinsi() {
        return axios.get(url + '/propinsi')
    }

    getKota(propinsi) {
        return axios.get(url + '/kota/' + propinsi)
    }

    getAllUpt() {
        return axios.get(url + '/allupt')
    }

    getUptById(kdUpt) {
        return axios.get(url + '/uptbyid/' + kdUpt)
    }

    getUserName(userName) {
        return axios.get(url + '/username/' + userName)
    }

    getUser(kdTrader) {
        return axios.get(url + '/user/' + kdTrader)
    }

    registrasiService(layanan) {
        return axios.post(url + '/crlayanan', layanan)
    }

    getLayanan(kdTrader) {
        return axios.get(url + '/getlayanan/' + kdTrader)
    }

    getAllTrader() {
        return axios.get(url + '/traders')
    }

    updateTrader(trader, kdTrader) {
        return axios.patch(url + '/register/' + kdTrader, trader)
    }

    updateUser(user, kdUser) {
        return axios.patch(url + '/user/' + kdUser, user)
    }

    updateLayanan(layanan, kode) {
        return axios.patch(url + '/crlayanan/' + kode, layanan)
    }

    getKdUptByTrader(kdTrader) {
        return axios.get(url + '/gettraderupt/' + kdTrader)
    }

    updateTraderUPT(traderUpt, kdTrader, kdUpt) {
        return axios.patch(url + '/uptraderupt/' + kdTrader + '/' + kdUpt,traderUpt)
    }
    
    createTraderUPT(traderUpt) {
        return axios.post(url + '/crtraderupt',traderUpt)
    }

    getFolderName() {
        return axios.get(url + '/filefolder')
    }
    
    getDokumen(fileID, kdDok) {
        return axios.get(url + '/dokumen/' + fileID + '/' + kdDok)
    }

    createTraderDokumen(traderDok) {
        return axios.post(url + '/crtraderdok', traderDok)
    }

    putDokumen(fileID, traderDok) {
        const formData = new FormData()
        formData.append("file", traderDok)
        return axios.post(urlFile + '/upload?nomorAju='+fileID, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }
}